import { apiResourceUrl } from "@ploy-lib/core";
import { Entity } from "@rest-hooks/rest";
import { BaseCamelCasedResource, paramsToString } from "./BaseResource";
export class LimitDetailEntity extends Entity {
    constructor() {
        super(...arguments);
        this.limitId = "";
        this.customerId = undefined;
        this.customers = [];
        this.engagementCustomerId = undefined;
        this.customerName = undefined;
        this.products = [];
        this.objectTypes = [];
        this.limitAmount = undefined;
        this.minEquity = undefined;
        this.loanAmount = undefined;
        this.objectCondition = undefined;
        this.terms = undefined;
        this.vatRule = undefined;
        this.remainingAmount = undefined;
        this.toDate = undefined;
        this.name = "";
        this.limitApplicationNumber = "";
        //	Calculated members:
        this.depotValueRate = undefined;
        this.pd = undefined;
        this.lgd = undefined;
        this.lgdAmount = undefined;
        this.usedAmount = undefined;
        this.depotValue = undefined;
        this.usedDepotValue = undefined;
        this.normalizedLoss = undefined;
        this.mainCustomerPd = undefined;
        this.isMainCustomer = false;
    }
    pk(parent, key) {
        return this.limitId?.toString();
    }
}
class LimitApplicationDataResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.limitApplicationDataId = 0;
        this.applicationId = undefined;
        this.customerId = undefined;
        this.fromDate = undefined;
        this.toDate = undefined;
        this.transferToCore = false;
        this.committed = false;
        this.limitIsInternal = false;
        this.limitDetails = [];
        this.limitCustomers = [];
        this.decisionTableTemplates = [];
        this.pDMain = undefined;
        this.riskGroupCustomer = undefined;
        this.lGDTotal = undefined;
        this.normalizedLossTotal = undefined;
        this.comments = {};
        this.applicationLink = undefined;
        this.informationText = undefined;
        this.warningText = undefined;
    }
    pk(parent, key) {
        return this.applicationId?.toString();
    }
    static url(urlParams = {}) {
        const { applicationId, customerId, ...searchParams } = urlParams;
        const url = super.url(urlParams);
        return `${url}${paramsToString(searchParams)}`;
    }
}
LimitApplicationDataResource.schema = {
    limitDetails: [LimitDetailEntity]
};
LimitApplicationDataResource.urlRoot = apiResourceUrl("application-limit");
export { LimitApplicationDataResource };
class LimitApplicationDataCustomerResource extends LimitApplicationDataResource {
    pk() {
        return this.customerId?.toString() || "";
    }
}
LimitApplicationDataCustomerResource.urlRoot = apiResourceUrl("application-limit/customer");
export { LimitApplicationDataCustomerResource };
//# sourceMappingURL=LimitApplicationResource.js.map